export const getPercentage = (value: number, sum: number): number => {
    if (sum === 0) {
        return 0;
    }
    return Math.round(100 - 100 * ((sum - value) / sum));
};
